// extracted by mini-css-extract-plugin
module.exports = {"boxTime":"Login_boxTime_2Z8r1","authbox":"Login_authbox_2IL1p","texth1":"Login_texth1_3omS8","texth1b":"Login_texth1b_3YPxZ"};